// From '@symbo.ls/utils', not the 'smbls' barrel — keeps the framework bundle
// out of the eager chunk (same fix as workspace/functions/extensionDesignSystem.js).
import { getCookie, deepClone } from '@symbo.ls/utils'
import { DS_DEFAULTS, DATA_DEFAULTS, SETTINGS_DEFAULTS } from './defaults.js'

// Guarded — this module is now reached by a plain `import _wsShared from
// '@symbo-ls/workspace-shared'` (the bare-root fix for the deep-subpath
// frank-serialization break, tickets/execution-board.md §1) from Node/bun
// test files and any future SSR context, none of which have `window`. A
// real browser always has it, so behavior there is unchanged.
const _loc = typeof window !== 'undefined' ? window.location : null
const [, embed] = (_loc ? _loc.pathname : '').split('/')
const isEmbed = embed === 'embed'

const urlParams = new URLSearchParams(_loc ? _loc.search : '')
const globalTheme = urlParams.get('globalTheme')
const followingUser = urlParams.get('followingUser')
const selected = urlParams.get('selected')

// @preserve-env
const ENV = process.env.NODE_ENV

export const state = {
  isRootState: true,
  isEmbed,
  // shareRootStateOnCanvas: true,

  ENV: getCookie('ENV') || ENV || 'development',
  // DEFAULTS: {
  //   DS_DEFAULTS,
  //   DATA_DEFAULTS,
  //   SETTINGS_DEFAULTS
  // },

  // ...deepClone(DATA_DEFAULTS),
  // schema: deepClone(DATA_DEFAULTS),

  canvas: {
    clients: {},
    pages: {}
  },

  settings: {
    remote: false,
    async: false,
    inspect: true,
    liveSync: true,
    syncCanvas: true
  },

  sampleText: 'Today is a big day for our tribe. The year ends.',

  framework: getCookie('framework') || 'symbols',
  pkgManager: getCookie('pkgManager') || 'npm',
  language: getCookie('language') || 'js',
  installTab: getCookie('installTab') || 'local',
  followingUser,
  selected,
  notifications: [
    // {
    //   title: '',
    //   message: '',
    //   type: ''
    // }
  ],
  // NotificationPanel (shared) All/Unread filter — declared here too so the
  // canvas standalone scope (links shared, not the workspace package) can
  // switch tabs; undeclared keys drop writes silently in v3.14.
  _notifFilter: 'all',
  // HeaderTabs (shared) reorder-drag UI state — same dual-declaration
  // rationale as _notifFilter above.
  _navbarReorder: false,
  _navbarDragPath: null,
  _navbarDragOverPath: null,
  _navbarDragOverAfter: false,

  sync: true,
  syncDesignSystem: true,
  syncState: true,
  syncComponents: true,
  syncPages: true,
  syncSnippets: true,
  syncSchema: true,
  chosenQueue: [],

  sharedLibrary: null,

  user: {
    smblsFromLocal: getCookie('smblsFromLocal') === 'true',
    topNavbarActive: getCookie('topNavbarActive') !== 'false',
    bottomNavbarActive: getCookie('bottomNavbarActive') === 'true',
    allowTitleOnArtboard: getCookie('allowTitleOnArtboard') !== 'false',
    autoSaveSettings: getCookie('autoSaveSettings') !== 'false',
    isSidebarSticky: getCookie('isSidebarSticky') === 'true',
    autoCleanConsole: getCookie('autoCleanConsole') === 'true',
    componentShowFilter: getCookie('componentShowFilter') || 'all',
    navbarPlacement: getCookie('navbarPlacement') || 'right',
    presentMode: getCookie('presentMode') !== 'false',
    showErrorBanner: getCookie('showErrorBanner') !== 'false',
    thumbnailPreview: getCookie('thumbnailPreview') === 'true',
    optimizedMode: getCookie('optimizedMode') === 'true',
    showGrid: getCookie('showGrid') === 'true',
    explorerAutoscroll: getCookie('explorerAutoscroll') !== 'false',
    debuggingMode: getCookie('debuggingMode') === 'true',
    useGlassmorphism: getCookie('useGlassmorphism') !== 'false',
    allowAutoPosition: getCookie('allowAutoPosition') !== 'false',
    allowInitialSelection: getCookie('allowInitialSelection') !== 'false',
    allowTabs: getCookie('allowTabs') !== 'false',
    showReferences: getCookie('showReferences') !== 'false',
    allowTeamCursors: getCookie('allowTeamCursors') !== 'false',
    allowFilesidebarPreview: getCookie('allowFilesidebarPreview') !== 'false',
    allowTabPreview: getCookie('allowTabPreview') !== 'false',
    useAnimations: getCookie('useAnimations') !== 'false',
    allowZoombar: getCookie('allowZoombar') !== 'false',
    zoomLevel: getCookie('zoomLevel') || 1,
    assistant: getCookie('assistant') !== 'false',
    openOnDblClick: getCookie('openOnDblClick') === 'true',
    autoSelectSidebar: getCookie('autoSelectSidebar') === 'true',
    allowCanvasReplaceRouter: getCookie('allowCanvasReplaceRouter') !== 'false',
    languageDirection: getCookie('languageDirection') || 'ltr',
    editorPanelsAtRight: getCookie('editorPanelsAtRight') === 'true'
  },

  sharedLibraries: [],

  clients: {
    localhost: {},
    cli: {},
    platform: {}
  },
  seats: 1,
  loading: true,

  // FALSE-ZERO-1 surface 4 — agent roster (Chat.js `ensureAgentRoster`,
  // consumed by workspace's "Your agents" widgets + tickets assignables +
  // canvas team-and-agents). Declared here (not left to fall through) per
  // the `_worldAtlasTick` lesson (analytics/state.js) — an undeclared key's
  // `root.update` is silently dropped by the v3.14 schema check, which
  // would re-introduce the exact bug this pair of keys exists to fix.
  //
  // Three distinguishable states, never collapsed into one "0":
  //   _agents === null && _agentsError === null  → still loading
  //   _agents === null && _agentsError !== null   → load failed
  //   Array.isArray(_agents)                      → loaded ([] is a real,
  //                                                  verified zero agents)
  _agents: null,
  _agentsError: null
}

export const globalState = state

export const optionsState = state

export default state
